//
// academy/{academyId}/post, feeds 의 모음
// 교사측에서 게시글과 알림장을 작성하고,
// 모든 사용자가 게시글 알림장을 조회하기 위함
//

import { API } from 'types/frontend/shared';
import { PostTypeT } from 'types/shared/core/Post';

//
//
//
//
//
//

//
//
// post
//

// 게시글 쓰기
export const CREATE_BOARD_POST = (academyId: number): API => ({
  method: 'POST',
  path: `/academy/${academyId}/post/boardPost`,
});

export const UPDATE_BOARD_POST = (academyId: number, postId: number): API => ({
  method: 'PUT',
  path: `/academy/${academyId}/post/boardPost/${postId}`,
});

//
//
//
// 알림장 쓰기
export const CREATE_NOTE_POST = (academyId: number): API => ({
  method: 'POST',
  path: `/academy/${academyId}/post/notePost`,
});

export const UPDATE_NOTE_POST = (academyId: number, postId: number): API => ({
  method: 'PUT',
  path: `/academy/${academyId}/post/notePost/${postId}`,
});

//
//
//
// 공통
export const DELETE_POST = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
): API => ({
  method: 'DELETE',
  path: `/academy/${academyId}/post/${postType}/${postId}`,
});

export const DO_RENOTIFY_POST = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
): API => ({
  method: 'POST',
  path: `/academy/${academyId}/post/${postType}/${postId}/renotify`,
});

export const DO_TOGGLE_POST_VISIBILITY = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
): API => ({
  method: 'POST',
  path: `/academy/${academyId}/post/${postType}/${postId}/visibility`,
});

export const DO_UPDATE_POST_REVIEW_STATUS = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
): API => ({
  method: 'POST',
  path: `/academy/${academyId}/post/${postType}/${postId}/reviewStatus`,
});

// post 한개 보기
export const READ_POST_CONTENT = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
  rid?: number,
): API => ({
  method: 'GET',
  path: `/academy/${academyId}/post/${postType}/${postId}${
    rid ? `/${rid}` : ``
  }`,
});

export const READ_POST_VIEWER_LIST = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
): API => ({
  method: 'GET',
  path: `/academy/${academyId}/post/${postType}/${postId}/viewers`,
});

// post 한개 보기
export const READ_BRAND_POST_CONTENT = (
  academyId: number,
  brandAcademyId: number,
  postId: number,
): API => ({
  method: 'GET',
  path: `/academy/${academyId}/post/brandPost/${brandAcademyId}/${postId}`,
});

// feeds, feed
export const READ_FEEDS = (academyId: number): API => ({
  method: 'GET',
  path: `/academy/${academyId}/feeds`,
});

export const READ_STUDENT_LAST_FEED_ITEM = (academyId: number): API => ({
  method: 'GET',
  path: `/academy/${academyId}/feeds/studentLastFeedItemPublishedAt`,
});

export const READ_FEED = (
  academyId: number,
  postType: PostTypeT,
  postId: number,
): API => ({
  method: 'GET',
  path: `/academy/${academyId}/feeds/${postType}/${postId}`,
});

export const READ_REVIEW_FEEDS = (
  academyId: number,
  scope: 'inbox' | 'mine',
): API => ({
  method: 'GET',
  path: `/academy/${academyId}/feeds/review?scope=${scope}`,
});
